import { makeStyles } from '@mui/styles';
import { colors } from '../../theme/Theme';

export const useStyles = makeStyles({
  email: {
    marginTop: 6,
  },
  login: {
    marginBottom: 8,
    textAlign: 'left',
    fontFamily: 'Roboto',
    fontWeight: 500,
  },
  submitBtn: {
    color: 'white',
  },
  label: {
    marginBottom: 24,
  },
  footer: {
    marginTop: -8,
  },
  loginBtn: {
    color: colors.primary,
    textTransform: 'none',
    fontWeight: 'bold',
    paddingLeft: 5,
  },
});
